import { useState, useEffect, useContext, useRef } from "react";
import DataTable from "react-data-table-component";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { AuthContext } from "../../Routes/AuthProvider"
import HeaderDashboard from "../../Components/HeaderDashboard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { lowFareFlightReport } from "../../Services/ReportsApi";

const LowFareFlight = () => {
  const { name, userName, roles, corporateId } = useContext(AuthContext);
  const isCorpTravel = roles?.includes("Corporate Traveller");
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    pnr: "",
    transactionId: "",
    bookingRefNo: "",
    paymentStatus: "",
    bookingStatus: "",
  });


  const tableWrapperRef = useRef(null);

  const [visibleColumns, setVisibleColumns] = useState([]);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  const today = new Date();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    $("#fromDate").datepicker({
      dateFormat: "dd/mm/yy",
      // changeMonth: true,
      // changeYear: true,
      // maxDate: new Date(),
      maxDate: 0,
      onSelect: function (dateText) {
        setFilters((prev) => ({
          ...prev,
          fromDate: dateText,
        }));
      },
    });
  }, []);

  useEffect(() => {
    $("#toDate").datepicker({
      dateFormat: "dd/mm/yy",
      minDate: filters.fromDate,
      maxDate: 0,
      onSelect: function (dateText) {
        setFilters((prev) => ({
          ...prev,
          toDate: dateText,
        }));
      },
    });
  }, []);

  const handleDateChange = (name, date) => {
    if (!date) {
      setFilters((prev) => ({ ...prev, [name]: "" }));
      return;
    }
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const formatted = `${day}/${month}/${year}`;

    setFilters((prev) => ({ ...prev, [name]: formatted }));
  };
  const parseDate = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split("/");
    return new Date(`${year}-${month}-${day}`);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Search Button Click
  const handleSearch = async () => {
    setLoading(true);
    try {
      // Prepare the request payload
      const requestBody = {
        FromDate: filters.fromDate,
        ToDate: filters.toDate,
        GDSPNR: filters.pnr,
        TrackID: filters.transactionId,
        ReferenceNo: filters.bookingRefNo,
        PaymentStatus: filters.paymentStatus,
        BookingStatus: filters.bookingStatus,
        UserName: userName,
      };


      //  Call API from external service
      const data = await lowFareFlightReport(requestBody);

      //console.log(data);
      setTransactions(data || []);

    } catch (error) {
      console.error("Error fetching data:", error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  // data table start

  const [filterText, setFilterText] = useState("");

  const airTransactions =
    transactions?.allTransactions?.airTransactionResponse || [];

  const filteredItems = airTransactions.filter(
    (item) =>
      item.referenceNo?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.gdspnr?.toLowerCase().includes(filterText.toLowerCase()) ||
      item.sector?.toLowerCase().includes(filterText.toLowerCase())
  );
  const StatusBadge = ({ status }) => {
    let bg = "#ffe5e5";
    let color = "#ff1f1f";

    if (
      status === "Success" ||
      status === "Confirmed" ||
      status === "Ticketed"
    ) {
      bg = "#e7f8ec";
      color = "#00a63e";
    }

    return (
      <span
        style={{
          background: bg,
          color: color,
          padding: "6px 12px",
          borderRadius: "30px",
          fontSize: "12px",
          fontWeight: "600",
        }}
      >
        {status}
      </span>
    );
  };
  const allColumns = [

    {
      id: "referenceNo",
      name: "Ref No.",
      selector: row => row.referenceNo,
      sortable: true,
      cell: row => (
        <span
          title="Details"
          style={{
            fontWeight: 700,
            color: "#0d47a1",
            cursor: "pointer",
          }}
        // onClick={() =>
        //     navigate(
        //         `/Reservations/Flight/TransactionDetails?referenceNo=${row.referenceNo}`
        //     )
        // }
        >
          {row.referenceNo}
        </span>
      ),

      priority: 1,
    },

    ...(!isCorpTravel ? [
      {
        id: "organization",
        name: "Entity Name",
        selector: row => row.agencyName,
        sortable: true,
        grow: 2,
        cell: row => (
          <>
            {row.agencyName} ({row.agentName})
          </>
        ),
        priority: 2,
      },
      {
        id: "paxName",
        name: "Pax Name",
        selector: row => row.passengerNames,
        sortable: true,
        grow: 2,
        cell: row => (
          <>
            {row.passengerNames}
          </>
        ),
        priority: 3,
      }
    ] : []),

    {
      id: "bookingDate",
      name: "Booking Date",
      selector: row => row.insertedOn,
      sortable: true,
      priority: 4,
      grow: 2,
      cell: row => (
        <>
          {row.insertedOn}
        </>
      )
    },

    {
      id: "sector",
      name: "Route",
      selector: row => row.sector,
      sortable: true,
      grow: 2,
      cell: row => (
        <>
          {row.sector}
        </>
      ),
      priority: 5,
    },

    {
      id: "travelDate",
      name: "Travel Date",
      selector: row => row.departureDate,
      sortable: true,
      priority: 6,
      grow: 2,
      cell: row => {
        const formatDate = (dateString) => {
          if (!dateString) return "-";

          const date = new Date(dateString);
          if (isNaN(date.getTime())) return "-";

          // Format: "05 Aug 2026 15:20"
          return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
          }).replace(/,/g, '');
        };

        return (
          <>
            {formatDate(row.departureDate)}
          </>
        );
      }
    },

    {
      id: "Airline",
      name: "Airline",
      selector: row => row.airlineName || "-",
      sortable: true,
      priority: 7,
    },

    {
      id: "pnr",
      name: "PNR",
      selector: row => row.gdspnr || "-",
      sortable: true,
      priority: 7,
    },

    {
      id: "paymentStatus",
      name: "Payment",
      selector: row => row.paymentStatus,
      sortable: true,
      cell: row => (
        <StatusBadge status={row.paymentStatus} />
      ),
      priority: 9,
    },

    {
      id: "bookingStatus",
      name: "Booking ",
      selector: row => row.bookingStatus,
      sortable: true,
      cell: row => (
        <StatusBadge status={row.bookingStatus} />
      ),
      priority: 10,
    },

    {
      id: "ticketStatus",
      name: "Ticket Status",
      selector: row => row.ticketingStatus,
      sortable: true,
      cell: row => (
        <StatusBadge status={row.ticketingStatus} />
      ),
      priority: 11,
    },

    {
      id: "fare",
      name: "Amount",
      selector: row => row.totalFare,
      sortable: true,
      //right: true,
      cell: row => (
        <span
          style={{
            fontWeight: 600,
            color: "#263238",
          }}
        >
          ₹ {Number(row.totalFare).toLocaleString("en-IN")}
        </span>
      ),
      priority: 12,
    },
    {
      id: "lowfare",
      name: "Low Fare",
      selector: row => row.lowFare,
      sortable: true,
      //right: true,
      cell: row => (
        <span
          style={{
            fontWeight: 600,
            color: "#263238",
          }}
        >
          ₹ {Number(row.lowFare).toLocaleString("en-IN")}
        </span>
      ),
      priority: 13,
    },
    {
      id: "SelectedFlightPrice",
      name: "Selected Flight Fare",
      selector: row => row.selectedFlightPrice,
      sortable: true,
      //right: true,
      cell: row => (
        <span
          style={{
            fontWeight: 600,
            color: "#263238",
          }}
        >
          ₹ {Number(row.selectedFlightPrice).toLocaleString("en-IN")}
        </span>
      ),
      priority: 14,
    },
    {
      id: "HighestFare",
      name: "Highest Fare",
      selector: row => row.highestFare,
      sortable: true,
      //right: true,
      cell: row => (
        <span
          style={{
            fontWeight: 600,
            color: "#263238",
          }}
        >
          ₹ {Number(row.highestFare).toLocaleString("en-IN")}
        </span>
      ),
      priority: 15,
    },
    {
      id: "profit",
      name: "Profit",
      selector: row => Number(row.LF.selectedFlightPrice || 0) - Number(row.lowFare || 0),
      sortable: true,
      cell: row => {
        const profit =
          Number(row.selectedFlightPrice || 0) - Number(row.lowFare || 0);

        return (
          <span
            style={{
              fontWeight: 600,
              color: profit >= 0 ? "#2e7d32" : "#d32f2f",
            }}
          >
            ₹ {profit.toLocaleString("en-IN")}
          </span>
        );
      },
      priority: 16,
    },
    {
      id: "selectedOption",
      name: "SelectedOption",
      selector: row => row.selectedOption || "-",
      sortable: true,
      priority: 17,
    },
  ];

  const calculateResponsiveColumns = () => {
    if (!tableWrapperRef.current) return;

    const containerWidth =
      tableWrapperRef.current.clientWidth;

    // Width required for + button
    const expanderWidth = 45;

    // Approximate minimum width for each column
    const columnWidths = {
      referenceNo: 130,
      paxName: 150,
      paymentStatus: 140,
      bookingStatus: 140,
      pnr: 100,
      ticketStatus: 130,
      bookingDate: 130,
      fare: 110,
      sector: 140,
      action: 90,
    };

    let availableWidth =
      containerWidth - expanderWidth;

    const visible = [];
    const hidden = [];

    // First column ALWAYS visible
    visible.push(allColumns[0]);

    availableWidth -= columnWidths.referenceNo;

    // Check remaining columns based on actual available width
    allColumns.slice(1).forEach(column => {
      const width = columnWidths[column.id] || 120;

      if (availableWidth >= width) {
        visible.push(column);
        availableWidth -= width;
      } else {
        hidden.push(column);
      }
    });

    setVisibleColumns(visible);
    setHiddenColumns(hidden);
  };

  useEffect(() => {
    calculateResponsiveColumns();

    const resizeObserver = new ResizeObserver(() => {
      calculateResponsiveColumns();
    });

    if (tableWrapperRef.current) {
      resizeObserver.observe(tableWrapperRef.current);
    }

    window.addEventListener(
      "resize",
      calculateResponsiveColumns
    );

    return () => {
      resizeObserver.disconnect();

      window.removeEventListener(
        "resize",
        calculateResponsiveColumns
      );
    };
  }, []);

  const ExpandedComponent = ({ data }) => {
    return (
      <div className="expanded-data">
        {hiddenColumns.map(column => (
          <div
            key={column.id}
            className="expanded-item"
          >
            <strong>
              {column.name}:
            </strong>

            <span>
              {column.cell
                ? column.cell(data)
                : column.selector
                  ? column.selector(data)
                  : "-"}
            </span>
          </div>
        ))}
      </div>
    );
  };



  const customStyles = {
    headRow: {
      style: {
        background: "#110942",
        minHeight: "55px"
      }
    },
    headCells: {
      style: {
        color: "#fff",
        fontWeight: 600,
        fontSize: "13px"
      }
    },
    rows: {
      style: {
        minHeight: "55px",
        '&:hover': {
          backgroundColor: "#f8f9ff"
        }
      }
    }
  };
  // const exportToExcel = (data, fileName = "FlightTransactions") => {
  //         const worksheet = XLSX.utils.json_to_sheet(data);

  //         const workbook = XLSX.utils.book_new();
  //         XLSX.utils.book_append_sheet(
  //             workbook,
  //             worksheet,
  //             "Transactions"
  //         );

  //         const excelBuffer = XLSX.write(workbook, {
  //             bookType: "xlsx",
  //             type: "array",
  //         });

  //         const fileData = new Blob(
  //             [excelBuffer],
  //             {
  //                 type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //             }
  //         );

  //         saveAs(fileData, `${fileName}.xlsx`);
  //     };

  const now = new Date();

  const day = String(now.getDate()).padStart(2, "0");
  const month = now.toLocaleString("en-US", { month: "short" });
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const excelName = `FlightTransaction_Report_${day}${month}_${hours}_${minutes}`;

  const exportToExcel = (data, fileName = "Transactions") => {
    const worksheet = XLSX.utils.json_to_sheet(data);

    worksheet["!cols"] = [
      { wch: 15 }, // ReferenceNo
      { wch: 50 }, // EntityName
      { wch: 20 }, // EmployeeId
      { wch: 30 }, // PaxName
      { wch: 15 }, // bookingStatus
      { wch: 15 }, // PaymentStatus
      { wch: 15 }, // gdspnr
      { wch: 15 }, // ticketingStatus
      { wch: 10 }, // totalFare
      // { wch: 15 }, // selectedOption
      // { wch: 10 }, // lowFare 
      { wch: 10 }, // Profit
      { wch: 20 }, // Airlines
      { wch: 20 }, // sector
      { wch: 20 }, // departureDate
      { wch: 15 }, // insertedOn
      { wch: 15 }, // lowFare
      { wch: 15 }, // SelectedFlightPrice
      { wch: 15 }, // HighestFlightPrice
      { wch: 15 }, // lowFareSelected
      { wch: 10 }, // Profit
      { wch: 15 }, // lowFareFlightNo
      { wch: 15 }, // ReasonForNotAcceptingLowFare
      { wch: 20 }, // approvedBy
      { wch: 20 }, // approvedBy
      { wch: 20 }, // approvedBy
      { wch: 20 }, // approvedBy
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Transactions");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(fileData, `${fileName}.xlsx`);
  };

  const exportFlightExcel = () => {
    const exportData = filteredItems.map((item) => ({
      ReferenceNo: item.referenceNo,
      EntityName: item.agencyName,
      EmployeeId: item.employeeId,
      PaxName: item.passengerNames,
      BookingStatus: item.bookingStatus,
      PaymentStatus: item.paymentStatus,
      Gdspnr: item.gdspnr,
      TicketingStatus: item.ticketingStatus,
      TotalFare: item.totalFare,
      // SelectedOption: item.selectedOption,
      // LowFare: item.totalFare,
      // Profit: Number(item.totalFare || 0) - Number(item.lowFare || 0),
      Airlines: item.airlineName,
      Sector: item.sector,
      DepartureDate: item.departureDate,
      InsertedOn: item.insertedOn,
      LowFare: item.lowFare,
      LowFare: item.selectedFlightPrice,
      LowFare: item.highestFare,
      LowFareSelected: item.selectedOption,
      Profit: Number(item.totalFare || 0) - Number(item.lowFare || 0),
      LowFareFlightNo: item.lowFareFlightNo,
      ReasonForNotAcceptingLowFare: item.ReasonForNotAcceptingLowFare,
      Level1Approver: item.level1Approver,
      Level1ApprovalStatus: item.Level1ApprovalStatus,
      Level2Approver: item.level2Approve,
      Level2ApprovalStatus: item.Level1ApprovalStatus
    }));

    exportToExcel(exportData, excelName);
  };

  const exportFlightPDF = () => {
    const doc = new jsPDF();

    autoTable(doc, {
      head: [[
        "Ref No",
        "Pax Name",
        "Booking Status",
        "Payment Status",
        "PNR",
        "Ticketing Status",
        "TotalFare",
        "Sector",
        "DepartureDate",
        "InsertedOn"
      ]],
      body: filteredItems.map((item) => [
        item.referenceNo,
        item.passengerNames,
        item.bookingStatus,
        item.paymentStatus,
        item.gdspnr,
        item.ticketingStatus,
        item.totalFare,
        item.sector,
        item.departureDate,
        item.insertedOn,
      ]),
    });
    doc.save(excelName + ".pdf");
  }

  return (
    <>
      <HeaderDashboard />
      <div className="toolbar py-2" id="kt_toolbar">
        <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
          <div className="flex-grow-1 flex-shrink-0 me-5">
            <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
              <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Reports</h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>

              <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li class="breadcrumb-item text-muted">Flight</li>
                <li class="breadcrumb-item">
                  <span class="bullet bg-gray-200 w-5px h-2px"></span>
                </li>

                <li class="breadcrumb-item text-gray-900">All Transactions</li>
              </ul>
            </div>
          </div>

        </div>
      </div>
      <section className="wraper">
        <div className="box_shadow mt-14">
          <div className="row">

            <div className="col-md-3 mb-1">
              <label>From Date</label>
              <input
                type="text"
                id="fromDate"
                className="form-control"
                placeholder="From Date"
                readOnly
              />
            </div>
            <div className="col-md-3 mb-1">
              <label>To Date</label>
              <input
                type="text"
                id="toDate"
                className="form-control"
                placeholder="To Date"
                readOnly
              />

            </div>

            <div className="col-md-3 mb-3">
              <label>PNR Number</label>
              <input
                className="form-control form-control-solid"
                type="text"
                name="pnr"
                value={filters.pnr}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label>Transaction ID</label>
              <input
                className="form-control form-control-solid"
                type="text"
                name="transactionId"
                value={filters.transactionId}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label>Booking RefNo</label>
              <input
                className="form-control form-control-solid"
                type="text"
                name="bookingRefNo"
                value={filters.bookingRefNo}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-3 mb-3">
              <label>Payment Status</label>
              <select
                className="form-select form-select-solid"
                name="paymentStatus"
                value={filters.paymentStatus}
                onChange={handleChange}
              >
                <option value="">- Select -</option>
                <option value="Success">Success</option>
                <option value="Requested">Requested</option>
                <option value="Failure">Failure</option>
                <option value="Refunded">Refunded</option>
                <option value="UnPaid">UnPaid</option>
              </select>
            </div>

            <div className="col-md-3 mb-3">
              <label>Booking Status</label>
              <select
                className="form-select form-select-solid"
                name="bookingStatus"
                value={filters.bookingStatus}
                onChange={handleChange}
              >
                <option value="">- Select -</option>
                <option value="Confirmed">Confirmed</option>
                <option value="Hold">Hold</option>
                <option value="Failure">Failure</option>
                <option value="Released">Released</option>
                <option value="OnRequest">OnRequest</option>
                <option value="Cancelled">Cancelled</option>
                <option value="Voided">Voided</option>
              </select>
            </div>

            <div className="col-md-3 mb-3">
              <button
                type="button"
                className="btn btn-primary mt-7"
                onClick={handleSearch}
                disabled={loading}
              >
                {loading ? "Loading..." : "Search"}
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="wraper">
        <div className='box_shadow'>

          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <button
                className="btn btn-success me-2"
                onClick={exportFlightExcel}
              >
                <i className="fa fa-file-excel"></i>
                Excel
              </button>

              <button
                className="btn btn-danger"
                onClick={exportFlightPDF}
              >
                <i className="fa fa-file-pdf"></i>
                PDF
              </button>
            </div>

            <div style={{ width: "320px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search Ref No, Pax Name, PNR..."
                value={filterText}
                onChange={(e) =>
                  setFilterText(e.target.value)
                }
              />
            </div>
          </div>
          <div
            ref={tableWrapperRef}
            className="transaction-table-wrapper"
          >
            <DataTable
              columns={visibleColumns}
              data={filteredItems}
              progressPending={loading}
              pagination
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              customStyles={customStyles}
              highlightOnHover
              responsive
              persistTableHead
              noDataComponent="No records found"
              expandableRows={hiddenColumns.length > 0}
              expandableRowsComponent={ExpandedComponent}
              expandOnRowClicked={false}
              expandableRowsHideExpander={false}
              expandableIcon={{
                collapsed: <span className="table-plus-icon">+</span>,
                expanded: <span className="table-plus-icon">−</span>,
              }}
            />
          </div>
          {/* <DataTable
                        columns={columns}
                        data={filteredItems}
                        progressPending={loading}
                        pagination
                        paginationPerPage={10}
                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                        highlightOnHover
                        striped
                        responsive
                        persistTableHead
                        customStyles={customStyles}
                        noDataComponent={
                            loading
                                ? "Loading..."
                                : "No records found"
                        }
                    /> */}

        </div>
      </section>

      {/* <section className='wraper'>
                <div className='box_shadow'>
                    <div className='col-md-12 col-lg-12'>
                        <div class="table-responsive">
                            <table class="table align-middle gs-0 gy-4">
                                <thead>
                                    <tr class="fw-bold bg-light">
                                        <th class="ps-4 rounded-start">Sr No</th>
                                        <th>RefNo.</th>
                                        <th>Payment Status</th>
                                        <th>Booking Status</th>
                                        <th>PNR</th>
                                        <th>Ticketing Status</th>
                                        <th>Booking Date</th>
                                        <th>Fare</th>
                                        <th>Sector</th>
                                        <th>Travel Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {transactions?.allTransactions?.airTransactionResponse?.length > 0 ? (
                                        transactions?.allTransactions?.airTransactionResponse?.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item.referenceNo}</td>
                                                <td>{item.paymentStatus}</td>
                                                <td>{item.bookingStatus}</td>
                                                <td>{item.gdspnr}</td>
                                                <td>{item.ticketingStatus}</td>
                                                <td>{item.insertedOn}</td>
                                                <td>{item.totalFare}</td>
                                                <td>{item.sector}</td>
                                                <td>{item.departureDate}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center text-muted">
                                                {loading ? "Loading..." : "No records found"}
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                               
                            </table>
                        </div>

                    </div>


                </div>
            </section> */}
    </>
  );
};

export default LowFareFlight;
